import { FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';
import { logError } from 'utils/monitoring';

/**
 * Handles RTK Query errors with detailed monitoring
 *
 * @param error - The RTK Query error object
 * @param endpoint - The name of the endpoint that failed
 * @param arg - The arguments passed to the query/mutation (optional)
 */
export const handleRTKQueryError = (error: unknown, endpoint: string, arg?: unknown) => {
    const rtqError = error as {
        error: FetchBaseQueryError;
        meta?: FetchBaseQueryMeta;
        isUnhandledError?: boolean;
    };

    // Don't log 401 Unauthorized or 403 Forbidden errors to monitoring
    // 401 errors are expected when sessions expire and trigger logout
    if (rtqError?.error?.status === 401 || rtqError?.error?.status === 403) {
        return;
    }

    const status = rtqError?.error?.status || 'Unknown';
    const errorMessage = `API ${status}: ${endpoint}`;
    const exception = new Error(errorMessage, { cause: error });

    logError(exception, {
        fingerprint: ['api-error', endpoint, String(status)],
        endpoint,
        arg,
        errorDetails: {
            error: rtqError?.error,
            isUnhandledError: rtqError?.isUnhandledError,
        },
        requestDetails: rtqError?.meta?.request
            ? {
                  url: rtqError.meta.request.url,
                  method: rtqError.meta.request.method,
                  headers: rtqError.meta.request.headers,
              }
            : null,
        responseDetails: rtqError?.meta?.response
            ? {
                  status: rtqError.meta.response.status,
                  statusText: rtqError.meta.response.statusText,
              }
            : null,
    });
};
